import { Box, Grid } from "@mui/material";
import { Page, Custom } from "components";
import { IPotluck } from "interfaces";
import { useTheme } from "contexts";
import { Fields } from "./Fields";
import { usePotluck } from "./usePotluck";

type Props = {
  potluck: IPotluck;
  onSubmit?: () => void;
};

export const Form = ({ potluck, onSubmit }: Props) => {
  const { theme } = useTheme();

  const { state, t, onChange, onCustomChange, handleSubmit } = usePotluck(
    potluck,
    onSubmit
  );

  if (!state) return <Page.Loader />;

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container gap={theme.spacing.sm}>
        <Fields
          state={state}
          t={t}
          onChange={onChange}
          onCustomChange={onCustomChange}
        />
        <Grid item xs={12}>
          <Box>
            <Custom.Button
              submit
              fullWidth
              trailing="right"
              variant="contained"
              sx={{ mt: theme.spacing.md }}
            >
              {t.action.save}
            </Custom.Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
